
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/presets",
      function () {
        return require("private-next-pages/presets/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/presets"])
      });
    }
  